import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  NuvemEnvioCreateDispatchesRequestDto,
  NuvemEnvioCreateDispatchesResponseDto,
} from '@tiendanube/common';
import ordersService from '../ordersService/ordersService';

export type statusType = 'idle' | 'loading' | 'success' | 'error';

export interface InterfaceCreateNuvemEnvioLabelsSchema {
  data: NuvemEnvioCreateDispatchesResponseDto;
  status: statusType;
}

export interface InterfaceNuvemEnvioOrdersSchema {
  createNuvemEnvioLabels: InterfaceCreateNuvemEnvioLabelsSchema;
}

const initialState: InterfaceNuvemEnvioOrdersSchema = {
  createNuvemEnvioLabels: {
    data: {
      contentDeclarationUrls: [],
      labelUrls: [],
      errors: [],
    },
    status: 'idle',
  },
};

export const createNuvemEnvioLabels = createAsyncThunk(
  'printManager/createNuvemEnvioLabels',
  async (params: NuvemEnvioCreateDispatchesRequestDto) =>
    ordersService.createNuvemEnvioLabels(params),
);

export const resetNuvemEnvioLabels = createAction(
  'printManager/resetNuvemEnvioLabels',
);

const nuvemEnvioOrdersSlice = createSlice({
  name: 'printManager',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNuvemEnvioLabels.fulfilled, (state, action) => {
        state.createNuvemEnvioLabels.status = 'success';
        state.createNuvemEnvioLabels.data = action.payload;
        return state;
      })
      .addCase(createNuvemEnvioLabels.pending, (state) => {
        state.createNuvemEnvioLabels.status = 'loading';
        return state;
      })
      .addCase(createNuvemEnvioLabels.rejected, (state) => {
        state.createNuvemEnvioLabels.status = 'error';
        return state;
      })
      .addCase(resetNuvemEnvioLabels, (state) => {
        state.createNuvemEnvioLabels = {
          data: {
            contentDeclarationUrls: [],
            labelUrls: [],
            errors: [],
          },
          status: 'idle',
        };
      });
  },
});

export const { reducer } = nuvemEnvioOrdersSlice;
